<template>
  <div class="partner-form">
    <el-dialog title="我要成为美菜合作司机" :visible.sync="visbility" width="30%" center>
      <el-form
        :model="driverForm"
        :rules="rules"
        ref="driverForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="司机姓名" prop="username">
          <el-input v-model="driverForm.username"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="driverForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="所在城市" prop="city">
          <el-select v-model="driverForm.city" filterable placeholder="请选择">
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择车型" prop="cartype">
          <el-select v-model="driverForm.cartype" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片验证" prop="captcha">
          <el-input v-model="driverForm.captcha" style="width:200px;"></el-input>
          <img :src="captchaSrc" />
          <i class="el-icon-refresh" @click="refresh"></i>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="commit">提交资料</el-button>
        <div style="display:flex;width:170px;margin:20px auto;">
          <img src="@/assets/images/new-img/driver/tel-ioc.png" width="29" />
          <div class="tel">{{$concatPhone || '4006-135-135' }}</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinsVerification } from "@/mixins/verification";
export default {
  name: "driverForm",
  props: {
    dialogVisbility: Boolean
  },
  mixins: [mixinsVerification],
  data() {
    var checkTel = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error("请输入正确的手机号码"));
      }
      callback();
    };
    return {
      cityList: "",
      driverForm: {
        username: "",
        mobile: "",
        city: "",
        cartype: "",
        captcha: ""
      },
      options: [
        {
          value: "无车",
          label: "无车"
        },
        {
          value: "大面包车",
          label: "大面包车"
        },
        {
          value: "商务车",
          label: "商务车"
        },
        {
          value: "平顶金杯",
          label: "平顶金杯"
        },
        {
          value: "高顶金杯",
          label: "高顶金杯"
        },
        {
          value: "依维柯",
          label: "依维柯"
        },
        {
          value: "3米3箱货",
          label: "3米3箱货"
        },
        {
          value: "4米2箱货",
          label: "4米2箱货"
        },
        {
          value: "5米2箱货",
          label: "5米2箱货"
        },
        {
          value: "6米2箱货",
          label: "6米2箱货"
        }
      ],
      visbility: this.dialogVisbility,
      rules: {
        username: [
          { required: true, message: "请输入司机姓名", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkTel, trigger: "blur" }
        ],
        city: [{ required: true, message: "请输入城市", trigger: "blur" }],
        cartype: [{ required: true, message: "请选择车型", trigger: "blur" }],
        captcha: [
          { required: true, message: "请输入图片验证码", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    commit() {
      this.$refs.driverForm.validate(valid => {
        if (valid) {
          let captcha = this.driverForm.captcha;
          let pramas = Object.assign({}, this.driverForm);
          delete pramas.captcha;
          _api.all.createDriver(pramas, { captcha }).then(res => {
            this.visbility = false;
            this.refresh();
            this.$message({
              message: "提交信息成功",
              type: "success"
            });
            this.$refs.driverForm.resetFields();
          });
        } else {
          return false;
        }
      });
    },
    getcityList() {
      _api.all.getRegisterCity().then(res => {
        this.cityList = res.data;
      });
    }
  },
  watch: {
    visbility(val) {
      this.$emit("update:dialogVisbility", val);
    },
    dialogVisbility(val) {
      this.visbility = val;
    }
  },
  mounted() {
    this.getcityList();
  }
};
</script>

<style lang="scss" scoped>
.tel {
  margin: 5px auto;
  width: 300px;
  font-size: 18px;
  color: #757575;
}
</style>
<style lang="scss">
.partner-form {
  .el-dialog {
    width: 800px !important;
    border-radius: 8px;
    .el-dialog__header {
      height: 120px;
      line-height: 100px;
      background: url(~@/assets/images/partner/t-line.png) no-repeat left bottom;
      .el-dialog__title {
        font-size: 30px;
      }
      .el-dialog__close {
        padding: 25px 20px 0 0;
        font-size: 36px;
      }
    }
    .el-dialog__body {
      text-align: initial;
      padding: 25px 150px 30px;
      .el-icon-refresh {
        font-size: 20px;
      }
    }
    .el-button {
      width: 280px;
      background: #64bd89;
    }
  }
}
</style>

